import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fileSize', standalone: true })
export class FileSizePipe implements PipeTransform {
  transform(value: number): string {
    if (value <= 1000) {
      return `${value} B`;
    }

    value = value / 1000;
    if (value <= 1024) {
      return `${value.toFixed(2)} KB`;
    }

    value = value / 1000;
    if (value <= 1000) {
      return `${value.toFixed(2)} MB`;
    }

    value = value / 1000;
    if (value <= 1000) {
      return `${value.toFixed(2)} GB`;
    }

    value = value / 1000;
    if (value <= 1000) {
      return `${value.toFixed(2)} TB`;
    }

    value = value / 1000;
    if (value <= 1000) {
      return `${value.toFixed(2)} PB`;
    }
  }
}
